<div class="min-h-screen dark:bg-slate-900 text-sm p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <!-- Page header -->
  <div class="animate-fade-in flex flex-col xl:flex-row xl:items-end justify-between mb-8 gap-4">
    <div>
      <div class="flex flex-wrap items-center gap-3">
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ช่วงยกเว้นค่าจอด</h1>
        <span
          class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold border border-amber-200/70 dark:border-amber-800/50">
          <span class="material-icons text-[14px]">schedule</span>
          Free Range
        </span>
      </div>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        กำหนดช่วงวันเวลายกเว้นค่าจอดตามทะเบียนรถ — เพิ่มทีละคัน หรือนำเข้าจากไฟล์
      </p>
    </div>

    <div class="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3">
      <div
        class="flex items-center gap-2 px-3 bg-white/95 dark:bg-slate-800/95 rounded-2xl border border-slate-100/50 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px] w-full sm:w-auto">
        <span class="material-icons text-slate-400 dark:text-slate-500 text-xl">calendar_today</span>
        <div class="relative w-full sm:w-[120px] h-full flex items-center">
          <div class="absolute inset-0 flex items-center justify-between px-2 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">expand_more</span>
          </div>
          <input #startDatePicker type="date" required [(ngModel)]="startDate" (change)="onDateChange()" [max]="endDate"
            (click)="startDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>
        <span class="text-slate-300 dark:text-slate-600">–</span>
        <div class="relative w-full sm:w-[120px] h-full flex items-center">
          <div class="absolute inset-0 flex items-center justify-between px-2 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">expand_more</span>
          </div>
          <input #endDatePicker type="date" required [(ngModel)]="endDate" (change)="onDateChange()" [min]="startDate"
            (click)="endDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>
      </div>

      <div *ngIf="lastFetchedTime" class="hidden sm:flex flex-col items-end justify-center text-right w-[100px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>

      <button type="button" (click)="onRefresh()" title="รีเฟรชข้อมูล"
        class="h-[46px] w-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center cursor-pointer">
        <span class="material-icons">refresh</span>
      </button>

      <button *ngIf="canCreate" type="button" (click)="openImport()"
        class="h-[46px] px-4 bg-white/95 dark:bg-slate-800/95 text-slate-700 dark:text-slate-200 font-bold rounded-2xl shadow-sm border border-slate-200 dark:border-slate-700 hover:border-amber-400 hover:text-amber-600 transition-all flex items-center justify-center gap-2 cursor-pointer">
        <span class="material-icons text-[20px]">upload_file</span> นำเข้าไฟล์
      </button>

      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="h-[46px] px-5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer border-none">
        <span class="material-icons text-[18px]">add</span> เพิ่มช่วง
      </button>
    </div>
  </div>

  <!-- Card -->
  <div class="bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
      <div>
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">event_available</span>
          รายการช่วงยกเว้น
          <span class="text-xs font-semibold text-slate-400">({{ totalItems() | number }})</span>
        </h3>
        <span *ngIf="siteState.selectedSite()?.name"
          class="inline-flex items-center gap-1 mt-2 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
          <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
        </span>
      </div>

      <div class="flex flex-col md:flex-row gap-3 w-full xl:w-auto">
        <!-- Status segmented -->
        <div class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl h-[46px]">
          <button *ngFor="let opt of statusOptions" type="button" (click)="setFilterEnabled(opt.value)"
            class="h-full px-3 rounded-lg text-xs font-bold transition-all cursor-pointer border-none whitespace-nowrap"
            [ngClass]="filterEnabled === opt.value
              ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm'
              : 'bg-transparent text-slate-400 hover:text-amber-600'">
            {{ opt.label }}
          </button>
        </div>

        <div class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px] md:min-w-[300px]">
          <span class="material-icons text-slate-400 text-xl ml-3">search</span>
          <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearchSubmit()" maxlength="50"
            placeholder="ค้นหาทะเบียนรถ"
            class="w-full pl-2 pr-2 h-full bg-transparent border-none text-sm font-medium focus:outline-none">
          <button *ngIf="searchText" type="button" (click)="searchText = ''; onSearchSubmit()"
            class="px-1 h-full text-slate-400 hover:text-slate-600 bg-transparent border-none cursor-pointer">
            <span class="material-icons text-[16px]">close</span>
          </button>
          <button type="button" (click)="onSearchSubmit()"
            class="w-[46px] h-full bg-amber-400 hover:bg-amber-500 text-slate-900 rounded-r-xl flex items-center justify-center cursor-pointer border-none transition-colors">
            <span class="material-icons">search</span>
          </button>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[420px] relative custom-scrollbar" [class.opacity-50]="isLoading()">
      <table class="w-full text-left border-collapse min-w-[1180px]">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
            <th class="p-4 pl-6">ทะเบียน</th>
            <th class="p-4">ช่วงวันเวลายกเว้น</th>
            <th class="p-4">สถานะ</th>
            <th class="p-4">ซิงก์ Taiwan</th>
            <th class="p-4">ผู้ทำรายการ</th>
            <th class="p-4">หมายเหตุ</th>
            <th class="p-4 pr-6 text-right">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById; let i = index"
            class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/40 transition-colors"
            [style.animation-delay.ms]="i * 25">
            <td class="p-4 pl-6">
              <span class="inline-flex items-center px-2.5 py-1 rounded-lg text-sm font-black tracking-tight bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-300">
                {{ item.licensePlate }}
              </span>
            </td>
            <td class="p-4 whitespace-nowrap">
              <div class="flex items-center gap-2">
                <div class="flex flex-col gap-1">
                  <span class="inline-flex items-center gap-1.5 text-xs font-bold text-slate-700 dark:text-slate-200 tabular-nums">
                    <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>{{ mapper.formatDisplayDateTime(item.startDate) }}
                  </span>
                  <span class="inline-flex items-center gap-1.5 text-xs font-bold text-slate-700 dark:text-slate-200 tabular-nums">
                    <span class="w-1.5 h-1.5 rounded-full bg-rose-400"></span>{{ mapper.formatDisplayDateTime(item.endDate) }}
                  </span>
                </div>
                <span class="px-2 py-0.5 rounded-full text-[10px] font-bold"
                  [ngClass]="rangePhaseClass(item)">{{ rangePhaseLabel(item) }}</span>
              </div>
            </td>
            <td class="p-4">
              <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold"
                [ngClass]="item.isEnabled
                  ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
                  : 'bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-300'">
                <span class="w-1.5 h-1.5 rounded-full" [ngClass]="item.isEnabled ? 'bg-emerald-500' : 'bg-slate-400'"></span>
                {{ item.isEnabled ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}
              </span>
            </td>
            <td class="p-4">
              <div class="flex flex-col gap-1">
                <span class="inline-flex items-center gap-1 text-xs font-bold"
                  [ngClass]="item.taiwanSyncStatus === 'success' ? 'text-emerald-600' : item.taiwanSyncStatus === 'failed' ? 'text-rose-500' : 'text-slate-500'">
                  <span class="material-icons text-[14px]">{{ item.taiwanSyncStatus === 'success' ? 'cloud_done' : item.taiwanSyncStatus === 'failed' ? 'cloud_off' : 'cloud_queue' }}</span>
                  {{ mapper.syncStatusLabel(item.taiwanSyncStatus) }}
                </span>
                <span *ngIf="item.taiwanLastSyncError" class="text-[11px] text-rose-400 max-w-[200px] truncate"
                  [title]="item.taiwanLastSyncError">{{ item.taiwanLastSyncError }}</span>
              </div>
            </td>
            <td class="p-4">
              <div class="font-bold text-slate-700 dark:text-slate-200">{{ item.requestDisplayName || '—' }}</div>
              <div class="text-[11px] text-slate-400 tabular-nums mt-0.5">{{ item.createDate ? (item.createDate | date:'dd/MM/yyyy HH:mm') : '—' }}</div>
            </td>
            <td class="p-4 text-slate-500 max-w-[200px] truncate" [title]="item.remark">{{ item.remark || '—' }}</td>
            <td class="p-4 pr-6">
              <div class="flex items-center justify-end gap-2">
                <button type="button" (click)="openEdit(item)"
                  class="w-9 h-9 rounded-xl border border-slate-200 dark:border-slate-700 flex items-center justify-center text-slate-500 hover:text-amber-500 hover:border-amber-300 cursor-pointer bg-white dark:bg-slate-800 transition-all"
                  [title]="item.canEdit ? 'แก้ไข' : 'ดูรายละเอียด'">
                  <span class="material-icons text-[18px]">{{ item.canEdit ? 'edit' : 'visibility' }}</span>
                </button>
                <button type="button" (click)="askToggle(item)" [disabled]="!item.canEdit || !canUpdate"
                  class="w-9 h-9 rounded-xl border border-slate-200 dark:border-slate-700 flex items-center justify-center cursor-pointer bg-white dark:bg-slate-800 hover:border-emerald-300 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                  [title]="item.isEnabled ? 'ปิดใช้งาน' : 'เปิดใช้งาน'">
                  <span class="material-icons text-[18px]" [ngClass]="item.isEnabled ? 'text-emerald-500' : 'text-slate-400'">power_settings_new</span>
                </button>
                <button *ngIf="canDelete" type="button" (click)="askCancel(item)" [disabled]="!canCancelRow(item)"
                  class="w-9 h-9 rounded-xl border border-rose-200 dark:border-rose-800 flex items-center justify-center text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 cursor-pointer bg-white dark:bg-slate-800 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                  [title]="cancelButtonTitle(item)">
                  <span class="material-icons text-[18px]">cancel</span>
                </button>
              </div>
            </td>
          </tr>

          <tr *ngIf="!selectedSiteId && !isLoading()">
            <td colspan="7" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center text-slate-400">
                <span class="material-icons text-4xl mb-2 opacity-40">location_off</span>
                <p class="font-bold text-slate-700 dark:text-slate-200">กรุณาเลือกลานจาก Navbar</p>
              </div>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !isLoading() && items().length === 0">
            <td colspan="7" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center text-slate-400">
                <span class="material-icons text-4xl mb-2 opacity-40">search_off</span>
                <p class="font-bold text-slate-700 dark:text-slate-200">ไม่พบข้อมูล</p>
                <p class="text-xs mt-1">ลองปรับช่วงวันที่ สถานะ หรือคำค้นหา</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4 rounded-b-[2rem]">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <div class="relative">
          <button type="button" (click)="togglePageSizeDropdown(); $event.stopPropagation()"
            class="h-9 px-3 rounded-lg bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 font-bold text-sm flex items-center gap-1 cursor-pointer hover:border-amber-300 transition-colors">
            {{ pageSize() }} / หน้า <span class="material-icons text-sm">expand_more</span>
          </button>
          <div *ngIf="isPageSizeOpen" (click)="$event.stopPropagation()"
            class="absolute bottom-full left-0 mb-2 z-50 min-w-full bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1">
            <button *ngFor="let size of pageSizeOptions" type="button" (click)="onPageSizeChange(size)"
              class="w-full px-3 py-2 text-left text-xs font-bold cursor-pointer border-none transition-colors"
              [ngClass]="size === pageSize()
                ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600'
                : 'bg-transparent text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-amber-900/20'">
              {{ size }}
            </button>
          </div>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let p of pagesArray" type="button" (click)="setPage(p)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer border-none"
          [ngClass]="p === currentPage()
            ? 'bg-amber-400 text-white shadow-sm'
            : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 bg-transparent'">
          {{ p }}
        </button>
        <button type="button" (click)="setPage(currentPage() + 1)"
          [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-discount-free-range *ngIf="isModalOpen()" [id]="selectedId()" [siteId]="selectedSiteId"
  [siteName]="siteState.selectedSite()?.name ?? ''" (close)="closeModal()" (saveSuccess)="loadTable()">
</app-modal-discount-free-range>

<app-modal-discount-free-range-import *ngIf="isImportOpen()" [siteId]="selectedSiteId"
  [siteName]="siteState.selectedSite()?.name ?? ''" (close)="closeImport()" (imported)="loadTable()">
</app-modal-discount-free-range-import>

<app-pss-confirm-modal *ngIf="confirmOpen() && confirmTarget && confirmMode === 'toggle'" title="ยืนยันเปลี่ยนสถานะ?"
  [message]="confirmTarget.isEnabled ? 'ต้องการปิดการยกเว้นค่าจอดของทะเบียน' : 'ต้องการเปิดการยกเว้นค่าจอดของทะเบียน'"
  [highlight]="confirmTarget.licensePlate" confirmLabel="ยืนยัน" icon="power_settings_new" variant="warning"
  [showIrreversibleNote]="false" (confirm)="confirmToggle()" (cancel)="cancelToggle()">
</app-pss-confirm-modal>

<app-pss-confirm-modal *ngIf="confirmOpen() && confirmTarget && confirmMode === 'cancel'" title="ยืนยันยกเลิกรายการ?"
  message="ต้องการยกเลิกช่วงยกเว้นค่าจอดของทะเบียน"
  [highlight]="confirmTarget.licensePlate"
  messageSuffix="จะปิดใช้งานที่ระบบและ Taiwan (ถ้ามี) — รายการยังอยู่ในตาราง"
  confirmLabel="ยกเลิก" icon="cancel" variant="danger"
  [showIrreversibleNote]="false" (confirm)="confirmToggle()" (cancel)="cancelToggle()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
